import { render } from "./ECoupons.vue?vue&type=template&id=c49ed6f8"
import script from "./ECoupons.vue?vue&type=script&lang=js"
export * from "./ECoupons.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\kamon\\Documents\\Workspace\\ECOUPONS\\coupons-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__